import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false
}

const loaderSlice = createSlice({
    name: 'loading-slice',
    initialState,
    reducers: {
        onLoading: (state, action) => {
            state.loading = action.payload
        }
    },
})

export const { onLoading } = loaderSlice.actions

export default loaderSlice.reducer